import React, { useRef } from "react";
import LandingPackageComponent from "../../../../components/user/LandingPackageComponent";
import "../nailcss/Nailservicescomponent.css";



function NailServicesComponent() {

  // sirf Nail Art hi dikhana hai, isliye ye fixed rahega
  const ActiveService = "Nail Art";

  const headingRefs = useRef({});

  const getHeadingRef = (key) => {
    if (!headingRefs.current[key]) {
      headingRefs.current[key] = React.createRef();
    }
    return headingRefs.current[key];
  };

  return (
    // id="services" — navbar / "Book Services Now" / footer ke #services
    // link se click hote hi yahi section smooth scroll ho ke khulega
    <div id="services" className='female-show-services-component-bg nail-service-section'>
      <div className='female-show-services-component-main-container1 nail-service-container'>

        {/* <div className="nail-service-eyebrow-row">
          <span className="nail-service-eyebrow">OUR SERVICES</span>
        </div> */}

        <h2 className="nail-service-main-heading">
          Nail Art &amp; Extension Services at Your Doorstep
        </h2>
        {/* <p className="nail-service-sub-heading">
          Handpicked nail care packages — pick a service below and get it booked in minutes.
        </p> */}

        <div className='female-show-services-comp-main-data-contatent nail-service-content'>

          <LandingPackageComponent
            ActiveService={ActiveService}
            getHeadingRef={getHeadingRef}
            getSmHeadingref={getHeadingRef}
          />

        </div>

      </div>
    </div>
  )
}

export default NailServicesComponent
